import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components';
import { DisplayUtils } from '../../utils';
import ContentLayout from '../../layouts/contentLayout/ContentLayout';
import './Accessibility.scss';
import { Link } from 'react-router-dom';

const Accessibility = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <div className="Accessibility">
        <div className="w-100 d-flex justify-content-center">
          {!DisplayUtils.isMobile() ? (
            <img src="/misc/icons/complete_logo_white.svg" alt="shop-icon" className="Accessibility__logo" />
          ) : (
            <div className="Accessibility__title">
              <Button
                icon="/misc/icons/arrow-left-blue.svg"
                action={() => history.goBack()}
                className="Button__transparent p-2 button-only-icon me-2"
                a11y={t('Globals.return')}
              />
              <h1>{t('Accessibility.head')}</h1>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-center">
          <div className="Accessibility__container">
            {!DisplayUtils.isMobile() && (
              <div className="Accessibility__container__title">
                <Button
                  icon="/misc/icons/arrow-left-pink.svg"
                  action={() => history.goBack()}
                  className="Button__transparent p-2 button-only-icon me-2"
                  a11y={t('Globals.return')}
                />
                <h1>{t('Accessibility.head')}</h1>
              </div>
            )}
            <div className='Accessibility__container__content'>
              <div className="Accessibility__container__content__description" >
                <li>
                  <Link to="/accessibility/web">
                    {t('Accessibility.titleWeb')}
                  </Link>
                </li>
                <br />
                <li>
                  <Link to="/accessibility/app">
                    {t('Accessibility.titleApp')}
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default Accessibility;
